<script lang="ts">
  import { Swiper } from 'swiper'
  import { Autoplay, Grid, Pagination } from 'swiper/modules'

  import { tick } from 'svelte'

  import type { Pathname } from '$app/types'
  import Service from '~/components/business/service.svelte'

  const shelfList: { title: string; description: string; icon: string; href?: Pathname }[] = [
    {
      title: 'Desenvolvimento de sistemas sob medida.',
      description:
        'Criar sistemas internos para tomadas de decisão, painéis administrativos de alta performance com automações, implementações de regras complexas e fluxos de trabalhos complexos para operações do seu negócio.',
      icon: 'vaadin:chart-3d',
      // href: resolve('/(index)/servicos/desenvolvimento-de-sistemas') as Pathname,
    },
    {
      title: 'Criação de sites com foco em conversão.',
      description:
        "Com a Lutruvials o preço de um site institucional é acessível e competitivo com seus concorrentes, nosso objetivo claro é gerar vendas e não apenas deixar o site 'existir', com otimização e manutenção mensal.",
      icon: 'solar:server-square-cloud-bold-duotone',
      // href: resolve('/(index)/servicos/criacao-de-sites-com-foco-em-conversao') as Pathname,
    },
    {
      title: 'Desenvolvimento de E-commerce.',
      description:
        'Abrir a sua loja virtual bem estrutura é complicado, com a Lutruvials a gente foca em uma estrutura robusta, performance e integrações pensando em escalabilidade na necessidade que seu negócio precisa no momento.',
      icon: 'solar:cart-2-line-duotone',
      // href: resolve('/(index)/servicos/desenvolvimento-de-ecommerce') as Pathname,
    },
    {
      title: 'Integrações e Automação de processos.',
      description:
        'Deixamos seu CRM, ERP integrado com gateways de pagamentos, software de planejamento e processos com automação de fluxos de trabalhos manuais, e seguros.',
      icon: 'fluent:flash-28-filled',
      // href: resolve('/(index)/servicos/integracoes-com-erp-crm-e-gateway-de-pagamento') as Pathname,
    },
  ]

  $effect.pre(() => {
    tick().then(() => {
      new Swiper('.swiper', {
        loop: false,
        spaceBetween: 32,
        slidesPerView: 3,
        modules: [Pagination, Autoplay, Grid],

        pagination: {
          enabled: true,
          el: '.swiper-pagination',
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-activate !bg-brand !opacity-100',
        },

        breakpoints: {
          0: { slidesPerView: 1, loop: false, grid: { fill: 'row', rows: 2 } },
          780: { slidesPerView: 2, grid: { fill: 'row', rows: 1 } },
          1024: { slidesPerView: 4, grid: { fill: 'row', rows: 2 } },
        },
      })
    })
  })
</script>

<style>
  .service-list :global(.service) {
    min-height: 180px;
  }
</style>

<section class="section | mb-[128px]">
  <div class="mx-auto w-full px-4 lg:w-[80%] lg:px-0">
    <h2 class="title | mb-8 text-center text-4xl font-medium md:text-5xl">
      Serviços de Desenvolvimento Web e Software
    </h2>

    <!-- Slider main container -->
    <div class="swiper service-list">
      <!-- Additional required wrapper -->
      <ul class="swiper-wrapper pb-[56px] lg:justify-center">
        <!-- Slides -->
        {#each shelfList as { icon, title, description, href }}
          <li class="swiper-slide">
            <article class="service-item | w-full grow">
              <div class="m-0">
                <Service {icon} {title} {description} {href} />
              </div>
            </article>
          </li>
        {/each}
      </ul>
      <!-- If we need pagination -->
      <div class="swiper-pagination"></div>

      <!-- If we need navigation buttons -->
      <div class="swiper-button-prev sr-only"></div>
      <div class="swiper-button-next sr-only"></div>
    </div>
  </div>
</section>
